/* XS collection chrome helper.

   The theme hides the Team (tag) filter on every collection that is not a
   sports collection — see the "Everywhere else: no Team filter at all" rule.
   Horizon's <overflow-list> still counts that hidden panel, decides it does not
   fit, and leaves a bare "More" word in the filter bar that opens a menu with
   nothing usable in it. Dropping the already-hidden panel out of the list makes
   the component recount and the stray "More" disappears.

   Nothing here changes which filters a shopper can reach: every panel removed
   was display:none before this ran.

   Scheduling note: no requestAnimationFrame. rAF is throttled to zero in a
   backgrounded tab, so a shopper who opens the collection in a background tab
   would come back to the stray "More" still sitting there. Timers keep firing. */
(function () {
  function prune() {
    var lists = document.querySelectorAll('overflow-list.facets__overflow-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var items = Array.prototype.slice.call(list.children);
      var changed = false;
      for (var j = 0; j < items.length; j++) {
        var panel = items[j].querySelector('details');
        if (panel && window.getComputedStyle(panel).display === 'none') {
          items[j].remove();
          changed = true;
        }
      }
      if (changed) window.dispatchEvent(new Event('resize'));
    }
  }

  var timer = null;
  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; prune(); }, 60);
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', function () { schedule(); window.setTimeout(prune, 600); });
  document.addEventListener('shopify:section:load', schedule);

  /* Horizon swaps the whole facets form when a filter changes, so watch for
     replacements and re-prune the new markup. */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('overflow-list') || node.querySelector('overflow-list')) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
